import { defineComponent as d, computed as o, openBlock as a, createElementBlock as c, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as p, createStaticVNode as f } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "32d2317d-1904-4229-a435-b1e5d4d84b00" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#32d2317d-1904-4229-a435-b1e5d4d84b00)" }, u = { key: 0 }, v = /* @__PURE__ */ f('<path fill="#eee" d="m0 160 256-32 256 32v192l-256 32L0 352Z"></path><path fill="#d80027" d="M0 0h512v160H0Z"></path><path fill="#333" d="M0 352h512v160H0Z"></path><path fill="#6da544" d="M233 294c0 25-26 42-26 42h98s-26-17-26-42z"></path><path fill="#496e2d" d="M256 176c-9 0-17 4-23 10a32 32 0 0 0-48 24 32 32 0 0 0 2 59 32 32 0 0 0 46 25c6 6 14 10 23 10s17-4 23-10c4 3 9 4 14 4 17 0 31-13 32-29a32 32 0 0 0 2-59 32 32 0 0 0-48-24c-6-6-14-10-23-10z"></path>', 5), g = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ d({
  __name: "et-or",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", k, [
        e.flagName ? (a(), c("title", u, n(e.flagName), 1)) : h("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: p({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  W as default
};
//# sourceMappingURL=et-or-c8da61dd.js.map
